import request from './request'
import { setToken } from '@/utils/auth'
import sendError from './sendError'

export default async function microSeviceFormatRequest(config) {
  const res = await request(config)
  if (res.data.ErrorCode === 0) {
    return res.data.Body
  }
  if (res.data.ErrorCode === 3) {
    setToken('')
    window.location.href = '/login'
    return Promise.reject(res.data.Msg)
  }
  if (res.data.ErrorCode === 8) {
    console.log('errorcode：8, 签名验证失败')
  }

  const chineseMsg = ['数据验证失败', '程序访问异常,请稍后重试！']
  const enMsg = [
    'Data verification failed',
    'Program access is abnormal, please try again later!'
  ]
  let curMsg = res.data.Msg
  if (/.*[\u4e00-\u9fa5]+.*/.test(curMsg)) {
    const idx = chineseMsg.indexOf(curMsg)
    sendError(idx >= 0 ? enMsg[idx] : curMsg)
  } else if (curMsg !== 'Signature verification failed!') {
    sendError(curMsg)
  }
  return Promise.reject(curMsg)
}
